import React, { useContext, useEffect } from 'react';
import styles from "./Dashboard.module.css"
import ExpenseList from '../Transctions'
import TotalAsset from '../InputForm'
import Edit from '../EditForm/EditForm'
import Modal from '../Modal/Modal'
import Categories, { OnlyCategoriesList } from '../Categories'
import Icons, { AiOutlineDollarCircle, BsGraphUpArrow, BsGraphDownArrow } from "../Icons";
import noteContext from '../Context/NoteContext';
export default function Dashboard({type}) {

    const {
        expenseList, setExpenseList,
        edittmp, setedittmp,
        ind, setind,
        categories, setCategories,
        isModal, setisModal,
        modalType, setModalType,
        allCat, setAllCat,
        isProfile, setIsProfile,
        Income, setIncome,
        Expense, setExpense,
        selectedCurrency, setSelectedCurrency,
    } = useContext(noteContext);
    const leftMobileClass = type === "Stat" ? styles.mobileHidden : "";
    const rightMobileClass = type === "Dash" ? styles.mobileHidden : "";

    const saving = Income - Expense
    const total = (Income + Expense) || 1;
    const incomePercnt = Math.round((Income / total) * 100);
    const expensePercnt = Math.round((Expense / total) * 100);
    let quality = undefined
    if (incomePercnt >= 0 && incomePercnt < 20) {
        quality = "Poor"
    }
    if (incomePercnt >= 20 && incomePercnt < 50) {
        quality = "Average"
    }
    if (incomePercnt >= 50 && incomePercnt < 80) {
        quality = "Good"
    }
    if (incomePercnt >= 80) {
        quality = "Excellent"
    }
    return (
        <>
            <div className={styles.dashboard} >
                <div className={`${styles.DivLeft} ${leftMobileClass}`}>
                    {/* 4 Value Divs */}
                    <div className={styles.Divx}>
                        {/* Number Div 1 */}
                        <div className={styles.Div1}>
                            <div style={{ margin: "3%" }}>
                                <div style={{ display: "flex", marginBottom: "10px", justifyContent: "space-between" }}>
                                    <div style={{ display: "flex" }}>
                                        <div className={styles.dollar}>
                                            <AiOutlineDollarCircle />
                                        </div>
                                        <p className={styles.graphtitle}>Income</p>
                                    </div>
                                    <div className={`${styles.arrow} ${Income >= 0 ? styles.profit : styles.loss}`}>
                                        {Income < 0 ? <BsGraphDownArrow /> : <BsGraphUpArrow />} <div style={{ fontSize: "0.5em" }}>x%</div>
                                    </div>
                                </div>
                                <div>
                                    <b style={{ fontSize: "1.2em" }}>{selectedCurrency.symbol}{Income}</b>
                                </div>
                            </div>
                        </div>
                        {/* Number Div 2 */}
                        <div className={styles.Div1}>
                            <div style={{ margin: "3%" }}>
                                <div style={{ display: "flex", marginBottom: "10px", justifyContent: "space-between" }}>
                                    <div style={{ display: "flex" }}>
                                        <div className={styles.dollar}>
                                            <AiOutlineDollarCircle />
                                        </div>
                                        <p className={styles.graphtitle}>Expense</p>
                                    </div>
                                    <div className={`${styles.arrow} ${Expense <= 0 ? styles.profit : styles.loss}`}>
                                        {Expense > 0 ? <BsGraphDownArrow /> : <BsGraphUpArrow />} <div style={{ fontSize: "0.5em" }}>x%</div>
                                    </div>
                                </div>
                                <div>
                                    <b style={{ fontSize: "1.2em" }}>{selectedCurrency.symbol}{Expense}</b>
                                </div>
                            </div>
                        </div>
                        {/* Number Div 3 */}
                        <div className={styles.Div1}>
                            <div style={{ margin: "3%" }}>
                                <div style={{ display: "flex", marginBottom: "10px", justifyContent: "space-between" }}>
                                    <div style={{ display: "flex" }}>
                                        <div className={styles.dollar}>
                                            <AiOutlineDollarCircle />
                                        </div>
                                        <p className={styles.graphtitle}>Savings</p>
                                    </div>
                                    <div className={`${styles.arrow} ${saving >= 0 ? styles.profit : styles.loss}`}>
                                        {saving < 0 ? <BsGraphDownArrow /> : <BsGraphUpArrow />} <div style={{ fontSize: "0.5em" }}>x%</div>
                                    </div>
                                </div>
                                <div>
                                    <b style={{ fontSize: "1.2em" }}>{selectedCurrency.symbol}{Income - Expense}</b>
                                </div>
                            </div>
                        </div>
                        {/* Number Div 4 */}
                        <div className={styles.Div1}>
                            <div style={{ margin: "3%" }}>
                                <div style={{ display: "flex", marginBottom: "10px", justifyContent: "space-between" }}>
                                    <div style={{ display: "flex" }}>
                                        <div className={styles.dollar}>
                                            <AiOutlineDollarCircle />
                                        </div>
                                        <p className={styles.graphtitle}>Remaining</p>
                                    </div>

                                    <div className={`${styles.arrow} ${saving >= 0 ? styles.profit : styles.loss}`}>
                                        {saving < 0 ? <BsGraphDownArrow /> : <BsGraphUpArrow />} <div style={{ fontSize: "0.5em" }}>x%</div>
                                    </div>
                                </div>
                                <div>
                                    <b style={{ fontSize: "1.2em" }}>{selectedCurrency.symbol}{Income - Expense}</b>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Transctions Div */}
                    <div className={styles.Transctiondiv}>
                        <div style={{ display: "flex" }}>
                            <div><b>Recent Transctions</b></div>
                        </div>
                        <div><ExpenseList /></div>
                    </div>
                </div>



                <div className={`${styles.DivRight} ${rightMobileClass}`}>
                    {/* Financial Score Div */}
                    <div className={styles.DivL}>
                        <div>
                            <p><b>Financial Score</b></p>
                            <p style={{ fontSize: "0.7rem" }}>Financial Quality</p>
                            <div style={{ display: "flex", fontSize: "1.2rem", justifyContent: "space-between", gap: "4rem" }}><b>{quality}</b><p><b>{incomePercnt === undefined ? 0 : incomePercnt}%</b></p></div>
                            <div style={{ display: "flex", gap: "5px" }}>
                                <div style={{ borderRadius: "5px", height: "20px", width: saving === 0 ? "50%" : `${expensePercnt}%`, backgroundColor: "var(--second-color)" }}></div>
                                <div style={{ borderRadius: "5px", height: "20px", width: saving === 0 ? "50%" : `${incomePercnt}%`, backgroundColor: "White" }}></div>
                            </div>
                            <div></div>
                        </div>
                    </div>
                    {/* Categories Div 4 */}
                    <div className={styles.DivM}>
                        <OnlyCategoriesList />
                    </div>
                </div>
            </div>
        </>
    )
}


